import { render, staticRenderFns } from "./WorkshopPublic.vue?vue&type=template&id=e8312078&scoped=true&"
import script from "./WorkshopPublic.vue?vue&type=script&lang=js&"
export * from "./WorkshopPublic.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopPublic.vue?vue&type=style&index=0&id=e8312078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8312078",
  null
  
)

export default component.exports